// SOFRA · motion leaf — per-row scroll stagger

import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import { usePrefersReducedMotion } from "@/lib/animation/prefers-reduced-motion";
import { DUR } from "@/features/landing/motion/tokens";

export function useSofraMotion(scope: React.RefObject<HTMLElement | null>) {
  const reduced = usePrefersReducedMotion();

  useGSAP(
    () => {
      const head = scope.current?.querySelector<HTMLElement>(".sofra__head");
      const rows = scope.current?.querySelectorAll<HTMLElement>(".plate");

      if (reduced) {
        gsap.set([head, ...(rows ?? [])], { clearProps: "all" });
        return;
      }

      if (head) {
        gsap.fromTo(head, { autoAlpha: 0, y: 32 }, {
          autoAlpha: 1, y: 0, duration: DUR.slow, ease: "power3.out",
          scrollTrigger: { trigger: head, start: "top 80%", toggleActions: "play none none reset" },
        });
      }

      if (rows && rows.length) {
        rows.forEach((row, i) => {
          gsap.fromTo(row, { autoAlpha: 0, y: 24 }, {
            autoAlpha: 1, y: 0, duration: DUR.normal, ease: "power3.out",
            delay: (i % 5) * 0.06,
            scrollTrigger: { trigger: row, start: "top 88%", toggleActions: "play none none reset" },
          });
        });
      }
    },
    { scope, dependencies: [reduced] }
  );
}